
export const REACT_APP_LOCALIZATION_DISABLED_ON_DEFAULT_LANGUAGE =
    process.env.REACT_APP_LOCALIZATION_DISABLED_ON_DEFAULT_LANGUAGE
export const REACT_APP_LOCALIZATION_BASE_PATH = process.env.REACT_APP_LOCALIZATION_BASE_PATH
export const REACT_APP_LANGUAGE_CHANGE_ENABLE = process.env.REACT_APP_LANGUAGE_CHANGE_ENABLE

